export default __webpack_public_path__ + "assets/models/aa9e41b12ac0dc66ce00454108faba80.glb";